/* Оценка на сайта (sections/hf-site-rating.liquid): popup with 5 stars and a mandatory comment; a discount code as thanks.
   Who sees it: a share of visitors (each browser draws a random number 0-99 once and keeps it; shown when it is below
   the percent setting), after N seconds spent on the site in this visit (summed across pages while the tab is visible;
   a pause of 30 min starts a new visit), once per round; closed without rating → again after N days.
   It waits while something else covers the page: the cookie banner (Consentmo), the cart, the menu, the filters,
   the luck wheel (html.hf-lw-lock) or a big fixed overlay from an app (the checkout), or while the visitor types.
   The rating goes as JSON (fetch) to the Lovable project "Hot Farm оценки на сайта"; the code shows after the save,
   also when the save fails (the visitor did the work). ?hf_rate=1 in the URL opens it at once, for checks.
   Automated browsers (navigator.webdriver) never get it by themselves. */
(function () {
  'use strict';

  var NS = 'hfRate:';
  var DAY = 24 * 60 * 60 * 1000;
  var VISIT_GAP = 30 * 60 * 1000;

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function store() { try { return window.localStorage; } catch (e) { return null; } }
  function read(k) { var s = store(); try { return s ? s.getItem(NS + k) : null; } catch (e) { return null; } }
  function write(k, v) { var s = store(); try { if (!s) return; if (v == null) s.removeItem(NS + k); else s.setItem(NS + k, String(v)); } catch (e) {} }
  function readJSON(k) { try { var v = read(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function writeJSON(k, v) { write(k, v == null ? null : JSON.stringify(v)); }
  function design() { return !!(window.Shopify && window.Shopify.designMode); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function forced() { return /[?&]hf_rate=1(?:&|$)/.test(location.search); }

  function uuid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    var s = '';
    for (var i = 0; i < 32; i++) s += Math.floor(Math.random() * 16).toString(16);
    return s;
  }
  function visitorId() { var v = read('vid'); if (!v) { v = uuid(); write('vid', v); } return v; }
  // One random number per browser, kept: the same visitor is always in or out of the share
  function bucket() {
    var b = parseInt(read('bucket'), 10);
    if (!(b >= 0 && b < 100)) { b = Math.floor(Math.random() * 100); write('bucket', b); }
    return b;
  }

  // Consent banner (Consentmo) still on screen: the popup waits. It draws in the shadow root of <csm-cookie-consent>.
  function bannerOpen() {
    var host = document.querySelector('csm-cookie-consent');
    if (!host) return false;
    var nodes = $$('*', host.shadowRoot || host).slice(0, 200);
    return nodes.some(function (c) {
      var q = c.getBoundingClientRect();
      if (q.width < 200 || q.height < 40 || q.bottom <= 0 || q.top >= window.innerHeight) return false;
      var cs = getComputedStyle(c);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0;
    });
  }

  // A fixed element straight under <body> covering half the screen or more (an app's modal, e.g. the checkout)
  function coveredByOverlay(root) {
    var vw = window.innerWidth, vh = window.innerHeight, kids = document.body.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.contains(root) || k.tagName === 'SCRIPT' || k.tagName === 'STYLE') continue;
      var cs = getComputedStyle(k);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
      var r = k.getBoundingClientRect();
      if (r.width * r.height >= vw * vh * 0.5) return true;
    }
    return false;
  }

  function pageBusy(root) {
    var b = document.body.classList, h = document.documentElement.classList;
    if (b.contains('hf-cart-open') || b.contains('hf-drawer-open') || b.contains('hf-filters-open') || h.contains('hf-lw-lock')) return true;
    var ae = document.activeElement;
    if (ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return true;
    return bannerOpen() || coveredByOverlay(root);
  }

  /* ---------- time on site (this visit, all pages, visible tab only) ---------- */
  var time = readJSON('t') || { s: 0, at: 0 };
  if (time.at && Date.now() - time.at > VISIT_GAP) time = { s: 0, at: 0 };
  var lastTick = Date.now();
  function tick() {
    var now = Date.now();
    if (document.visibilityState === 'visible') time.s += Math.min(5, (now - lastTick) / 1000);
    lastTick = now;
    // another tab of the same visit may be further along: take the larger count instead of adding both
    var other = readJSON('t');
    if (other && other.at && now - other.at < VISIT_GAP && other.s > time.s) time.s = other.s;
    time.at = now;
    writeJSON('t', time);
    return time.s;
  }

  function init(root) {
    if (!root || root.hfRate) return;
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-rate-data]').textContent); } catch (e) { return; }
    var overlay = root.querySelector('[data-rate-overlay]');
    var dialog = root.querySelector('[data-rate-dialog]');
    var form = root.querySelector('[data-rate-form]');
    var starsEl = root.querySelector('[data-rate-stars]');
    var radios = $$('[data-rate-radio]', root);
    var stars = $$('[data-rate-star]', root);
    var word = root.querySelector('[data-rate-word]');
    var ta = root.querySelector('[data-rate-comment]');
    var hp = form ? form.querySelector('input[name="website"]') : null;
    var msg = root.querySelector('[data-rate-msg]');
    var submit = root.querySelector('[data-rate-submit]');
    var screenForm = root.querySelector('[data-rate-screen="form"]');
    var screenThanks = root.querySelector('[data-rate-screen="thanks"]');
    var tTitle = root.querySelector('[data-rate-ttitle]');
    var copyBtn = root.querySelector('[data-rate-copy]');
    var codeEl = root.querySelector('[data-rate-code]');
    var status = root.querySelector('[data-rate-status]');
    if (!overlay || !dialog || !form || !ta || !submit) return;

    var endpoint = root.getAttribute('data-endpoint') || '';
    var code = root.getAttribute('data-code') || '';
    var round = root.getAttribute('data-round') || '1';
    var percent = Math.min(100, Math.max(0, parseFloat(root.getAttribute('data-percent')) || 0));
    var delay = Math.max(0, parseFloat(root.getAttribute('data-delay')) || 0);
    var days = Math.max(1, parseFloat(root.getAttribute('data-days')) || 30);
    var minChars = Math.max(1, parseInt(root.getAttribute('data-min'), 10) || 3);
    var words = (data.words || []).map(function (w) { return String(w).trim(); });
    var copyLabel = copyBtn ? copyBtn.textContent : '';
    var selected = 0;
    var busy = false;
    var rated = false;
    var lastFocus = null;
    var openedAt = 0;

    function say(text, ok) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('is-ok', !!ok);
    }

    /* ---------- stars ---------- */
    function light(n) {
      stars.forEach(function (s) { s.classList.toggle('is-lit', +s.getAttribute('data-rate-star') <= n); });
    }
    function setWord(n) { if (word) word.textContent = n > 0 ? (words[n - 1] || '') : ''; }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        selected = +r.value || 0;
        light(selected);
        setWord(selected);
        if (starsEl) starsEl.classList.remove('is-invalid');
        if (msg && msg.textContent === data.err_rating) say('');
      });
    });
    stars.forEach(function (s) {
      var n = +s.getAttribute('data-rate-star');
      s.addEventListener('mouseenter', function () { light(n); setWord(n); });
      s.addEventListener('mouseleave', function () { light(selected); setWord(selected); });
    });

    /* ---------- open / close ---------- */
    function isOpen() { return !overlay.hidden; }
    function open(fromUser) {
      if (isOpen()) return;
      lastFocus = document.activeElement;
      overlay.hidden = false;
      openedAt = Date.now();
      document.documentElement.classList.add('hf-rate-lock');
      try { dialog.focus({ preventScroll: true }); } catch (e) { dialog.focus(); }
      // shown by itself: not again before "days", even if the visitor leaves without closing it
      if (!fromUser && !design()) write(round + ':closed', Date.now());
    }
    function close() {
      if (!isOpen()) return;
      overlay.hidden = true;
      document.documentElement.classList.remove('hf-rate-lock');
      if (!rated && !design()) write(round + ':closed', Date.now());
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }
    $$('[data-rate-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    // Esc closes even when the focus has left the dialog (a tap on plain text puts it on the body)
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { e.preventDefault(); close(); }
    });
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', dialog)
        .filter(function (x) { return (x.offsetParent !== null || x === document.activeElement) && !x.closest('.hf-rate__hp'); })
        .filter(function (x) { return !(x.type === 'radio' && !x.checked && selected > 0); });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* ---------- send ---------- */
    function thanks(state) {
      rated = true;
      write(round + ':done', Date.now());
      write(round + ':closed', null);
      screenForm.hidden = true;
      screenThanks.hidden = false;
      if (status) status.textContent = state === 'error' ? (data.error || '') : '';
      if (tTitle) { try { tTitle.focus({ preventScroll: true }); } catch (e) { tTitle.focus(); } }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var comment = ta.value.replace(/\s+/g, ' ').trim();
      ta.removeAttribute('aria-invalid');
      if (starsEl) starsEl.classList.remove('is-invalid');
      if (!selected) {
        if (starsEl) starsEl.classList.add('is-invalid');
        say(data.err_rating);
        if (radios[0]) radios[0].focus();
        return;
      }
      if (comment.length < minChars) {
        ta.setAttribute('aria-invalid', 'true');
        say((data.err_comment || '').replace(/\[n\]/g, minChars));
        ta.focus();
        return;
      }
      busy = true;
      submit.setAttribute('aria-busy', 'true');
      say(data.saving, true);
      var body = {
        rating: selected,
        comment: comment,
        visitor_id: visitorId(),
        page_url: location.href,
        page_path: location.pathname,
        referrer: document.referrer || null,
        template: data.template || null,
        locale: data.locale || null,
        country: data.country || null,
        seconds_on_site: Math.round(time.s),
        viewport_width: window.innerWidth,
        theme_id: data.theme_id != null ? String(data.theme_id) : null,
        theme_role: data.theme_role || null,
        discount_code: code,
        website: hp ? hp.value : ''
      };
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (json) { return { status: res.status, json: json }; });
        })
        .then(function (r) {
          var c = r.json && r.json.code;
          if (r.status === 429) { say(data.rate_limited); return; }
          if (r.status === 400 && c === 'comment_too_short') { ta.setAttribute('aria-invalid', 'true'); say((data.err_comment || '').replace(/\[n\]/g, minChars)); ta.focus(); return; }
          if (r.status === 400 && c === 'invalid_rating') { say(data.err_rating); return; }
          // saved or already saved; anything else is our problem, not the visitor's: the code is the thanks either way
          thanks(r.status >= 200 && r.status < 300 ? 'saved' : 'error');
        })
        .catch(function () { thanks('error'); })
        .then(function () {
          busy = false;
          submit.removeAttribute('aria-busy');
          if (!rated) return;
          say('');
        });
    });

    if (copyBtn) copyBtn.addEventListener('click', function () {
      var text = codeEl ? codeEl.textContent : code;
      var ok = function () {
        copyBtn.textContent = copyBtn.getAttribute('data-copied') || copyLabel;
        setTimeout(function () { copyBtn.textContent = copyLabel; }, 2000);
      };
      var fallback = function () {
        try {
          var r = document.createRange();
          r.selectNodeContents(codeEl);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(r);
          if (document.execCommand('copy')) ok();
        } catch (e) {}
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(ok, fallback);
      else fallback();
    });

    root.hfRate = { open: open, close: close, seconds: function () { return time.s; } };

    /* ---------- when ---------- */
    if (design()) return;
    var force = forced();
    if (force) { open(true); return; }
    if (read(round + ':done')) return;
    var closedAt = +read(round + ':closed');
    if (closedAt && Date.now() - closedAt < days * DAY) return;
    if (bucket() >= percent) return;
    // Automated browsers (screenshot scripts of the other sessions, checks) never get it by themselves
    if (navigator.webdriver) return;

    var stableSince = 0;
    (function loop() {
      if (isOpen()) return;
      if (tick() < delay) { stableSince = 0; return setTimeout(loop, 1000); }
      // the page must be quiet for a moment before the popup comes: the wheel or a drawer that opens first wins
      if (document.visibilityState !== 'visible' || pageBusy(root)) { stableSince = 0; return setTimeout(loop, 500); }
      if (!stableSince) { stableSince = Date.now(); return setTimeout(loop, 500); }
      if (Date.now() - stableSince < 1500) return setTimeout(loop, 500);
      open(false);
    })();
  }

  function initAll(scope) { $$('[data-hf-rate]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor: selecting the section opens the popup
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-hf-rate]');
    if (!root) return;
    init(root);
    if (root.hfRate) root.hfRate.open(true);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-hf-rate]');
    if (root && root.hfRate) root.hfRate.close();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-hf-rate]')) document.documentElement.classList.remove('hf-rate-lock');
  });
})();
